export const DEPARTMENTS = [
  { key: 1, text: "Atlántida", value: 1 },
  // { key: 2, text: "Choluteca", value: 2 },
  // { key: 3, text: "Colón", value: 3 },
  // { key: 4, text: "Comayagua", value: 4 },
  // { key: 5, text: "Copán", value: 5 },
  { key: 6, text: "Cortés", value: 6 },
  // { key: 7, text: "El Paraíso", value: 7 },
  { key: 8, text: "Francisco Morazán", value: 8 },
  // { key: 9, text: "Gracias a Dios", value: 9 },
  // { key: 10, text: "Intibucá", value: 10 },
  // { key: 11, text: "Islas de la Bahía", value: 11 },
  // { key: 12, text: "La Paz", value: 12 },
  // { key: 13, text: "Lempira", value: 13 },
  // { key: 14, text: "Ocotepeque", value: 14 },
  // { key: 15, text: "Olancho", value: 15 },
  // { key: 16, text: "Santa Bárbara", value: 16 },
  // { key: 17, text: "Valle", value: 17 },
  // { key: 18, text: "Yoro", value: 18 }
]

export const COUNTRIES_CODE = [
  { key: "hn", value: "+504", flag: "hn", text: "Honduras +504" },
  { key: "ar", value: "+54", flag: "ar", text: "Argentina +54" },
  { key: "bz", value: "+501", flag: "bz", text: "Belice +501" },
  { key: "bo", value: "+591", flag: "bo", text: "Bolivia +591" },
  { key: "br", value: "+55", flag: "br", text: "Brasil +55" },
  { key: "ca", value: "+1", flag: "ca", text: "Canadá +1" },
  { key: "cl", value: "+56", flag: "cl", text: "Chile +56" },
  { key: "co", value: "+57", flag: "co", text: "Colombia +57" },
  { key: "cr", value: "+506", flag: "cr", text: "Costa Rica +506" },
  { key: "ec", value: "+593", flag: "ec", text: "Ecuador +593" },
  { key: "sv", value: "+506", flag: "sv", text: "El Salvador +506" },
  { key: "us", value: "+1", flag: "us", text: "Estados Unidos +1" },
  { key: "gu", value: "+502", flag: "gu", text: "Guatemala +502" },
  { key: "mx", value: "+52", flag: "mx", text: "México +52" },
  { key: "ni", value: "+505", flag: "ni", text: "Nicaragua +505" },
  { key: "pa", value: "+507", flag: "pa", text: "Panamá +507" },
  { key: "py", value: "+595", flag: "py", text: "Paraguay +595" },
  { key: "pe", value: "+51", flag: "pe", text: "Perú +51" },
  { key: "uy", value: "+598", flag: "uy", text: "Uruaguay +598" },
  { key: "ve", value: "+58", flag: "ve", text: "Venezuela +58" },
]

export const COUNTRIES = [
  { key: "hn", value: "Houndras", flag: "hn", text: "Honduras" },
  { key: "ar", value: "Argentina", flag: "ar", text: "Argentina" },
  { key: "bz", value: "Belice", flag: "bz", text: "Belice" },
  { key: "bo", value: "Bolivia", flag: "bo", text: "Bolivia" },
  { key: "br", value: "Brasil", flag: "br", text: "Brasil" },
  { key: "ca", value: "Canada", flag: "ca", text: "Canadá" },
  { key: "cl", value: "Chile", flag: "cl", text: "Chile" },
  { key: "co", value: "Colombia", flag: "co", text: "Colombia" },
  { key: "cr", value: "Costa Rica", flag: "cr", text: "Costa Rica" },
  { key: "ec", value: "Ecuador", flag: "ec", text: "Ecuador" },
  { key: "sv", value: "El Salvador", flag: "sv", text: "El Salvador" },
  { key: "us", value: "Estados Unidos", flag: "us", text: "Estados Unidos" },
  { key: "gu", value: "Guatemala", flag: "gu", text: "Guatemala" },
  { key: "mx", value: "Mexico", flag: "mx", text: "México" },
  { key: "ni", value: "Nicaragua", flag: "ni", text: "Nicaragua" },
  { key: "pa", value: "Panama", flag: "pa", text: "Panamá" },
  { key: "py", value: "Paraguay", flag: "py", text: "Paraguay" },
  { key: "pe", value: "Peru", flag: "pe", text: "Perú" },
  { key: "uy", value: "Uruguay", flag: "uy", text: "Uruaguay" },
  { key: "ve", value: "Venezuela", flag: "ve", text: "Venezuela" },
]
